(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["horologic-care-service"] && !Shopify.designMode) return;
  try {
    
(function(){function validateField(field){field.setCustomValidity(field.value.trim()?'':field.dataset.careError);}document.addEventListener('input',function(event){if(event.target.matches('.horologic-service__form [data-care-required]'))validateField(event.target);});document.addEventListener('submit',function(event){var form=event.target;if(!form.matches('.horologic-service__form'))return;form.querySelectorAll('[data-care-required]').forEach(function(field){field.value=field.value.trim();validateField(field);});if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}},true);}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horologic-movement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const startHorologicMovementVideos = (root = document) => {
      root.querySelectorAll('horologic-movement[data-autoplay="true"] video').forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');

        const tryPlay = () => {
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        };

        if (video.readyState >= 2) {
          tryPlay();
        } else {
          video.addEventListener('loadeddata', tryPlay, { once: true });
          video.addEventListener('canplay', tryPlay, { once: true });
        }
      });
    };

    const boot = () => startHorologicMovementVideos(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    window.addEventListener('pageshow', boot);
    document.addEventListener('shopify:section:load', (event) => startHorologicMovementVideos(event.target));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) boot();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
